import Modal from 'components/Layout/Modal';
import React from 'react';
import { paymentCategory, paymentType } from 'utils/constants';

const PreviewReceiptPopup = ({ onHide, abstractDetails }) => {
  const {
    user_name,
    co_authors,
    paper_title,
    event_name,
    paper_id,
    presentation_type,
    payment_category,
    reference_no,
    payment_type,
    currency_type,
    total_amount,
    collector_name,
    verifier_name,
  } = abstractDetails;

  const categoryName =
    paymentCategory.find((item) => item.value === payment_category)?.name ||
    '-';

  const paymentTypeValue =
    paymentType.find((item) => item.value === payment_type)?.name || '-';

    
  return (
    <Modal
      titleBesideClose="Preview Receipt"
      onHide={onHide}
      size="xl"
      isTitleBorder
      isTitleVerticalCenter
    >
      <div className="cps-20 cpe-20 cpb-30">
        <div className="row cpt-25 cpb-25">
          <div className="col-12">
            <h4 className="text-16-500 color-new-car ">
              Author & Co-Author Details
            </h4>
          </div>

          <div className="col-md-3 mb-3">
            <div className="h-100">
              <h6 className="text-14-400-18">Author:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {user_name || '-'}
              </p>
            </div>
          </div>

          {co_authors?.map((author, index) => (
            <div className="col-md-3 mb-3" key={author.id}>
              <div className="h-100">
                <h6 className="text-14-400-18">Co-Author {index + 1}:</h6>
                <p className="mb-0 text-14-300-18 color-black-olive">
                  {author.name || '-'}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Conference Info Section */}
        <div className="row cpb-25">
          <div className="col-12">
            <h4 className="text-16-500 color-new-car">
              Conference & Abstract Info
            </h4>
          </div>

          <div className="col-12 mb-3">
            <div>
              <h6 className="text-14-400-18">Conference Name:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {event_name || '-'}
              </p>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div>
              <h6 className="text-14-400-18">Paper Title:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {paper_title || '-'}
              </p>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            <div className="h-100">
              <h6 className="text-14-400-18">Paper ID:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive text-dots" title={paper_id}>
                {paper_id || '-'}
              </p>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            <div className="h-100">
              <h6 className="text-14-400-18">Presentation Type:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {presentation_type || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Payment Details Section */}
        <div className="row mb-3">
          <div className="col-12">
            <h4 className="text-16-500 color-new-car">Payment Details</h4>
          </div>

          <div className="col-12 d-flex flex-wrap gap-5">
            <div>
              <h6 className="text-14-400-18">Payment Category:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {categoryName || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Reference No.:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {reference_no || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Payment Type:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {paymentTypeValue || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Currency Type:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {currency_type || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Total Amount:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {total_amount || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Collected By:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {collector_name || '-'}
              </p>
            </div>

            <div>
              <h6 className="text-14-400-18">Verified By:</h6>
              <p className="mb-0 text-14-300-18 color-black-olive">
                {verifier_name || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewReceiptPopup;
